<!--
 * @Author: Yehon He 1427749162@qq.com
 * @Date: 2025-03-30 23:14:24
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-04-15 23:42:57
 * @FilePath: \ecloud-web\packages\mall-cook-platform\src\custom-schema-template\components\ModuleTypeSelector\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="module-type-selector">
    <div class="module-type-grid">
      <div 
        v-for="type in moduleTypes" 
        :key="type.value"
        class="module-type-item"
        @click="selectType(type)"
      >
        <i :class="type.icon"></i>
        <span>{{ type.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleTypeSelector',
  
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  
  data() {
    return {
      moduleTypes: [
        { label: '活动简介', value: 'intro', icon: 'el-icon-tickets' },
        { label: '会场直播', value: 'live', icon: 'el-icon-video-camera' },
        { label: '新闻资讯', value: 'news', icon: 'el-icon-document' },
        { label: '图片集', value: 'images', icon: 'el-icon-picture' },
        { label: '视频集', value: 'videos', icon: 'el-icon-film' },
        { label: '文档中心', value: 'documents', icon: 'el-icon-folder' },
        { label: '个人中心', value: 'profile', icon: 'el-icon-user' },
        { label: '演讲嘉宾', value: 'speakers', icon: 'el-icon-microphone' },
        { label: '会议日程', value: 'schedule', icon: 'el-icon-date' },
        { label: '报名入口', value: 'register', icon: 'el-icon-s-promotion' },
        { label: '合作伙伴', value: 'partners', icon: 'el-icon-connection' },
        { label: '站外链接', value: 'external', icon: 'el-icon-link' },
        { label: '站内链接', value: 'internalLink', icon: 'el-icon-link' }
      ]
    };
  },
  
  methods: {
    selectType(type) {
      this.$emit('input', type.value);
      this.$emit('select', type);
    }
  }
};
</script>

<style lang="scss" scoped>
.module-type-selector {
  width: 100%;
  box-sizing: border-box;
  
  .module-type-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 10px;
    
    .module-type-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 25px 10px;
      background-color: #f5f7fa;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      
      i {
        font-size: 28px;
        margin-bottom: 12px;
        color: #409EFF;
      }
      
      span {
        font-size: 15px;
        font-weight: 500;
      }
      
      &:hover {
        background-color: #ecf5ff;
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style> 